import React from 'react';
import EditableContentMultilang from '../components/EditableContentMultilang';
import './ContactPage.css';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// --- Funzione Helper per rilevare se è un dispositivo mobile ---
const isMobileDevice = () => {
    // Controlla lo user agent per parole chiave comuni dei dispositivi mobili
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};


// --- Componente MailtoButton Aggiornato ---
const MailtoButton = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const requestedRoom = location.state?.requestedRoom || '';

    const yourEmail = 'info@anticopioldefeltre.it'; // <-- INSERISCI QUI LA TUA EMAIL
    const subject = t('mailtoSubject');

    const bodyTemplate = t('mailtoBody', { room: requestedRoom || ' ' });

    // Codifica i componenti per l'URL
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(bodyTemplate);

    // Costruisci i due link diversi
    const mailtoLink = `mailto:${yourEmail}?subject=${encodedSubject}&body=${encodedBody}`;
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${yourEmail}&su=${encodedSubject}&body=${encodedBody}`;

    // Controlla se l'utente è su mobile
    const isMobile = isMobileDevice();

    return (
        <div className="mailto-button-container">
            <EditableContentMultilang docPath="contact_page/details" field="mail1" elementType="h2" />
            <EditableContentMultilang docPath="contact_page/details" field="mail2" elementType="textarea" />
            <a href="/configura-camera" className="cta-button contact-configure-btn">
                Prenota il tuo soggiorno
            </a>
        </div>
    );
};


// --- Componente Pagina Contatti (invariato) ---
const ContactPage = () => {
  return (
            <div className="contact-page">
            <section className="page-header">
                <div className="container">
                    <EditableContentMultilang docPath="contact_page/header" field="title" elementType="h1" />
                    <EditableContentMultilang docPath="contact_page/header" field="subtitle" elementType="textarea" />
                </div>
            </section>
            <section className="content-section">
                <div className="container contact-container">
                    <div className="contact-details">
                        <EditableContentMultilang docPath="contact_page/details" field="title" elementType="h2" />
                        <EditableContentMultilang docPath="contact_page/details" field="address" elementType="textarea" />
                        <EditableContentMultilang docPath="contact_page/details" field="phone" elementType="textarea" />
                        <EditableContentMultilang docPath="contact_page/details" field="email" elementType="textarea" />
                        <EditableContentMultilang docPath="contact_page/details" field="other_info_title" elementType="h3" />
                        <EditableContentMultilang docPath="contact_page/details" field="other_info" elementType="textarea" />
                    </div>
                    <MailtoButton />
                </div>
            </section>
        </div>
  );
};

export default ContactPage;

